import { render, staticRenderFns } from "./briefTrainingReport.vue?vue&type=template&id=6ec24668&scoped=true"
import script from "./briefTrainingReport.vue?vue&type=script&lang=js"
export * from "./briefTrainingReport.vue?vue&type=script&lang=js"
import style0 from "./briefTrainingReport.vue?vue&type=style&index=0&id=6ec24668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec24668",
  null
  
)

export default component.exports